import { LitElement, html, utils } from '@hh/global.js'

class HHProductGrid extends LitElement {
  static properties = {
    nextPageUrl: { type: String, attribute: 'next-page-url' },
  }

  constructor() {
    super()

    this.nextPageUrl = ''
  }

  connectedCallback() {
    super.connectedCallback()

    this.lastProductItem = this.querySelector('.page-last-item')
    this.updateVisibleProductCount()
    if (this.nextPageUrl != '') this.appendNewPageProducts()

    this.toggleGridButton = document.querySelector('.js-toggle-grid')
    this.toggleGridButton.addEventListener(
      'click',
      this.toggleGridLayout.bind(this)
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  updateVisibleProductCount() {
    const visibleProductCount = this.querySelectorAll('.js-product-grid-item').length
    const countEl = document.querySelector('.js-collection-visible-count')
    const countTextEl = document.querySelector('.js-collection-item-count-text')

    if (countEl) {
      countEl.textContent = visibleProductCount
    }

    if (countTextEl) {
      countTextEl.textContent = visibleProductCount === 1 ? 'item' : 'items'
    }
  }

  appendNewPageProducts() {
    this.waitForEle('.page-last-item').then(() => {
      if (!this.nextPageUrl) return

      this.fetchNextPage()
    })
  }

  waitForEle(selector) {
    const elem = document.querySelector(selector)
    return new Promise((resolve) => {
      if (elem) {
        return resolve(elem)
      }

      const observer = new MutationObserver((mutations) => {
        if (elem) {
          resolve(elem)
          observer.disconnect()
        }
      })

      observer.observe(elem, {
        childList: true,
        subtree: true,
      })
    })
  }

  async fetchNextPage() {
    await fetch(this.nextPageUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        const collectionHTML = new DOMParser().parseFromString(
          html,
          'text/html'
        )

        return collectionHTML
      })
      .then((collectionHTML) => {
        const gridContainer = this.querySelector('.js-collection-grid')
        const newPageUrl = collectionHTML.querySelector('hh-product-grid')
        const newGridContainer = collectionHTML.querySelector(
          '.js-collection-grid'
        )

        gridContainer.insertAdjacentHTML(
          'beforeend',
          newGridContainer.innerHTML
        )
        this.updateVisibleProductCount()
        this.lastProductItem.classList.remove('page-last-item')
        this.lastProductItem = this.querySelector('.page-last-item')

        return newPageUrl
      })
      .then((newPageUrl) => {
        if (
          newPageUrl.getAttribute('next-page-url') != undefined ||
          newPageUrl.getAttribute('next-page-url') != ''
        ) {
          this.nextPageUrl = newPageUrl.getAttribute('next-page-url')
          this.appendNewPageProducts()
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  toggleGridLayout(event) {
    event.target.classList.toggle('toggle')
    const productGridContainer = this.querySelector('.js-collection-grid')
    productGridContainer.classList.toggle('toggle')
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-grid', HHProductGrid)
